import qs from 'qs';

interface ISearchConfig {
  collectionId: string;
  filterKey: string;
  filterValue: string;
  options: string;
  query: string;
  type: string;
}

const formatSearchConfigOptionsToUrl = (options) => {
  const optionsObj = qs.parse(options);
  const filterString = qs.stringify(optionsObj.filters, { indices: false });

  return optionsObj.filters ? `${filterString}` : '';
};

export const getLinkFromSearchConfig = (
  { collectionId, filterKey, filterValue, options, query, type }: ISearchConfig,
  isMicrofrontend?: boolean,
) => {
  const filterOptions = formatSearchConfigOptionsToUrl(options);

  if (type === 'search') {
    return `/${isMicrofrontend ? 'new-search' : 'search'}?query=${query}${
      filterOptions ? `&${filterOptions}` : ''
    }`;
  }

  if (type === 'collection') {
    return `/collections/${collectionId}${filterOptions ? `?${filterOptions}` : ''}`;
  }

  if (type === 'brand') {
    return `/brand/${collectionId}${filterOptions ? `?${filterOptions}` : ''}`;
  }

  if (type === 'browse') {
    return `/search?browseKey=${filterKey}&browseValue=${filterValue}${
      filterOptions ? `&${filterOptions}` : ''
    }`;
  }

  if (collectionId === 'gift-cards') {
    return '/gift-cards';
  }

  return '';
};
